import ToastDialog from "components/Common/ToastDialog";
import withRouter from "components/Common/withRouter";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "react-spinner-loader";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import * as Yup from "yup";
//Import Breadcrumb
import Breadcrumbs from "components/Common/BreadcrumbTitle";
import { useAsyncDebounce } from "react-table";
import API_SERVICES from "constants/app.constants";
import {
  addCommercial,
  getOneCommercial,
  updateCommercial,
} from "../../http/fundLync/entityAndAddress.helper";
import { getDropDownList } from "../../http/fundLync/dropdown.helper"
import { callGetPanDetails } from "../../http/gstin/gstin";
import { decryptedValue } from "common/utility";
const AddCommercials = (props) => {
  document.title = "Add Commericals | FundLync";
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const isOpen = true;
  const isAlready = false;
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [id, setId] = useState(null);
  const [commercialData, setCommercialData] = useState(null);
  const [isPanSerching, setIsPanSerching] = useState(false);
  const [entityName, setEntityName] = useState("")
  const [isShowSubProduct, setIsShowSubProduct] = useState(false);
  const [subProductList, setSubProductList] = useState([]);
  const [productTypeList, setProductTypeList] = useState([])
  const [productList, setProductList] = useState([])
  const [isReceivableFinancing, setIsReceivableFinancing] = useState([])
  const user = decryptedValue(localStorage.getItem("user"));

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    setId(searchParams.get("id"));
    getDropDownList({ dropdownName: "Product type" })
      .then((response) => {
        const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Product type")?.dropdownValues || []
        setProductTypeList(dropdownValues)
      })
      .catch((error) => {

      });
  }, []);

  useEffect(() => {
    if (id) {
      getOneCommercial({ id: id })
        .then((res) => {
          setCommercialData(res.data);
          getDropDownList({ dropdownName: res.data.productType })
            .then((response) => {
              const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == res.data.productType)?.dropdownValues || []
              setProductList(dropdownValues)
            })
            .catch((error) => {

            });
          if (res.data.product == 'Payable Financing' || res.data.product == 'Receivable Financing') {
            setIsShowSubProduct(true)
            getDropDownList({ dropdownName: res.data.product })
              .then((response) => {
                const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == res.data.product)?.dropdownValues || []
                setSubProductList(dropdownValues)
              })
              .catch((error) => {

              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [id]);

  const commercialValidationSchema = commercialFieldsData.reduce(
    (acc, field) => {
      if (!(isReceivableFinancing == 'Receivable Financing' && field.fieldName == 'selfFinanaces')) {
        acc[`${field.fieldName}Type`] = Yup.string();
        acc[`${field.fieldName}Frequency`] = Yup.string();
        acc[`${field.fieldName}Occurrence`] = Yup.string();
        acc[`${field.fieldName}Value`] = Yup.number()
          .typeError("Loan Requirement Amount must be a number")
          .when(`${field.fieldName}Type`, {
            is: "Percentage",
            then: Yup.number()
              .typeError("Loan Requirement Amount must be a number")
              .max(
                100,
                `${field.fieldLabel} value must be less than or equal to 100`
              ),
          })
          .min(0, `${field.fieldLabel} value must not be less than 0`);
      }
      return acc;
    },
    {}
  );

  const extractChargesFromData = (data) => {
    if (!data?.commercials[0]) return {};
    const chargesData = {};
    for (const field of commercialFieldsData) {
      chargesData[`${field.fieldName}Type`] = data.commercials[0][`${field.fieldName}`]?.[`Type`] || "";
      chargesData[`${field.fieldName}Frequency`] = data.commercials[0][`${field.fieldName}`]?.[`Frequency`] || "";
      chargesData[`${field.fieldName}Occurrence`] = data.commercials[0][`${field.fieldName}`]?.[`Occurrence`] || "";
      chargesData[`${field.fieldName}Value`] = data.commercials[0][`${field.fieldName}`]?.[`Value`] || "";
    }
    return chargesData;
  };

  const chargesInitialValues = extractChargesFromData(commercialData);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      entityName: commercialData?.entityName || "",
      pan: commercialData?.pan || "",
      email: commercialData?.email || "",
      productType: commercialData?.productType || "",
      product: commercialData?.product || "",
      subProduct: commercialData?.subProduct || "",
      entityId:user.entityId,
      entityType:user.entityType,
      ...chargesInitialValues,
    },
    validationSchema: Yup.object({
      entityName: Yup.string().required("Please Enter Entity Name"),
      pan: Yup.string()
        .matches(API_SERVICES.PAN_PATTERN, "Enter a valid PAN number")
        .required("PAN is required"),
      email: isOpen
        ? Yup.string().required("Please Enter Email")
        : Yup.string(),
      productType: Yup.string().required("Please Select Product Type"),
      product: Yup.string().required("Please Select Product"),
      subProduct: isShowSubProduct
        ? Yup.string().required("Please Select Sub Product")
        : null,

      ...commercialValidationSchema,
    }),

    onSubmit: (values) => {
      setLoader(true);
      const processedValues = { ...values };
      const commercialEntry = {};

      commercialFieldsData.forEach((field) => {
        const typeField = `${field.fieldName}Type`;
        const valueField = `${field.fieldName}Value`;
        const timeField = `${field.fieldName}Frequency`;
        const cycleField = `${field.fieldName}Occurrence`;
        commercialEntry[`${field.fieldName}`] = {}
        commercialEntry[`${field.fieldName}`][`Type`] = processedValues[`${typeField}`]
        commercialEntry[`${field.fieldName}`][`Value`] = processedValues[`${valueField}`]
        commercialEntry[`${field.fieldName}`][`Frequency`] = processedValues[`${timeField}`]
        commercialEntry[`${field.fieldName}`][`Occurrence`] = processedValues[`${cycleField}`]

        delete processedValues[typeField];
        delete processedValues[timeField];
        delete processedValues[cycleField];
        delete processedValues[valueField];
      });

      processedValues.commercials = [commercialEntry];

      if (id) {
        updateCommercial({ id: id, ...processedValues })
          .then((data) => {
            if (data.status) {
              setLoader(false);
              setToastInfo({
                message: "Commercial updated successfully",
                showToast: true,
                role: "success",
              });
              validation.resetForm();
              setTimeout(() => {
                navigate(`/${user.roleName}/commercials`);
              }, 1000);
            } else {
              setToastInfo({
                message: data.message,
                showToast: true,
                role: "error",
              });
              setLoader(false);
            }
          })
          .catch((err) => {
            setLoader(false);
            setToastInfo({
              message: "Commercial update failed",
              showToast: true,
              role: "error",
            }).finally(f => {
              setLoader(false);
            });
          });
      } else {
        addCommercial(processedValues)
          .then((data) => {
            if (data.status) {
              setLoader(false);
              setToastInfo({
                message: "Commercial added successfully",
                showToast: true,
                role: "success",
              });
              validation.resetForm();
              setTimeout(() => {
                navigate(`/${user.roleName}/commercials`);
              }, 1000);
            } else {
              setLoader(false);
              setToastInfo({
                message: data.message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((err) => {
            setLoader(false);
            setToastInfo({
              message: "Commercial add failed",
              showToast: true,
              role: "error",
            }).finally(f => {
              setLoader(false);
            });
          });
      }
    },
  });


  const onPanChange = useAsyncDebounce((value) => {
    if (!validation.errors.pan) findPanDetails(value);
  }, 400);

  const findPanDetails = (pan) => {
    setIsPanSerching(true);
    callGetPanDetails({ pan: pan })
      .then((result) => {
        if (result.code == 200 && result.status) {
          const { data: panDetails } = result;
          const { full_name } = panDetails;
          setEntityName(full_name)
          validation.setFieldValue('entityName', full_name)
        } else {
          setToastInfo({
            message: "Incorrect PAN",
            showToast: true,
            role: "error",
          });
          validation.setFieldValue("companyName", "");
          validation.setFieldValue("constitution", "");
        }
      })
      .catch((e) => {
        setToastInfo({
          message: "PAN not found",
          showToast: true,
          role: "error",
        });
        validation.setFieldValue("companyName", "");
        validation.setFieldValue("constitution", "");
      })
      .finally((f) => {
        setIsPanSerching(false);
      });
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="ADD COMMERCIALS" />
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <div>
                      <h5 style={{ marginTop: "1%" }}>Details</h5>
                    </div>
                    <div className="mb-3 row">

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">PAN*</Label>
                        <Input
                          name="pan"
                          type="text"
                          placeholder="Enter PAN"
                          onChange={(e) => {
                            validation.handleChange(e);
                            onPanChange(e.target.value);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.pan || ""}
                          invalid={
                            !!(validation.touched.pan && validation.errors.pan)
                          }
                        />
                        {isPanSerching && (
                          <div
                            className="spinner-border progress-load"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        )}
                        {validation.touched.pan && validation.errors.pan ? (
                          <FormFeedback type="invalid">
                            {validation.errors.pan}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">Entity Name*</Label>
                        <Input
                          name="entityName"
                          type="text"
                          placeholder="Enter Entity Name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.entityName || ""}
                          invalid={
                            !!(validation.touched.entityName &&
                              validation.errors.entityName)
                          }
                          disabled={entityName}
                        />
                        {validation.touched.entityName &&
                          validation.errors.entityName ? (
                          <FormFeedback type="invalid">
                            {validation.errors.entityName}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">Entity User Email*</Label>
                        <Input
                          name="email"
                          type="email"
                          placeholder="Enter Email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            !!(validation.touched.email && validation.errors.email)
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">Product Type*</Label>
                        <Input
                          name="productType"
                          type="select"
                          onChange={e => {
                            validation.setFieldValue("product", '')
                            validation.setFieldValue("subProduct", '')
                            setIsShowSubProduct(false)
                            getDropDownList({ dropdownName: e.target.value })
                              .then((response) => {
                                const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == e.target.value)?.dropdownValues || []
                                setProductList(dropdownValues)
                              })
                              .catch((error) => {

                              });
                            validation.handleChange(e)
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.productType || ""}
                          invalid={
                            validation.touched.productType &&
                            validation.errors.productType
                          }
                        >
                          <option value="" disabled>Select Product type</option>
                          {productTypeList.map((option, index) => (
                            <option key={option.id} value={option.dropdownValue}>
                              {option.displayName}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.productType &&
                          validation.errors.productType ? (
                          <FormFeedback type="invalid">
                            {validation.errors.productType}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">Select Product*</Label>
                        <Input
                          name="product"
                          type="select"
                          onChange={e => {
                            validation.handleChange(e)
                            validation.setFieldValue("subProduct", '')
                            if (e.target.value == "Payable Financing" ||
                              e.target.value == "Receivable Financing") {
                              setIsShowSubProduct(true)
                              setIsReceivableFinancing(e.target.value)
                              getDropDownList({ dropdownName: e.target.value })
                                .then((response) => {
                                  const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == e.target.value)?.dropdownValues || []
                                  setSubProductList(dropdownValues)
                                })
                                .catch((error) => {

                                });
                            } else {
                              setIsShowSubProduct(false)
                            }
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.product || ""}
                          invalid={
                            validation.touched.product &&
                            validation.errors.product
                          }
                        >
                          <option value="" disabled>Select Product</option>
                          {productList.map((option, index) => (
                            <option key={option.id} value={option.dropdownValue}>
                              {option.displayName}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.product &&
                          validation.errors.product ? (
                          <FormFeedback type="invalid">
                            {validation.errors.product}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      {isShowSubProduct && (
                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">Select Sub Product*</Label>
                          <Input
                            name="subProduct"
                            type="select"
                            placeholder="Select Sub Product"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.subProduct || ""}
                            invalid={
                              validation.touched.subProduct && validation.errors.subProduct
                            }
                          >
                            <option value="" disabled>Select Sub Product*</option>
                            {subProductList.map((option, index) => (
                              <option key={option.id} value={option.dropdownValue}>
                                {option.displayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.subProduct && validation.errors.subProduct ? (
                            <FormFeedback type="invalid">
                              {validation.errors.subProduct}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      )}

                    </div>
                    <div style={{ marginTop: "2rem" }}>
                      <h5 style={{ marginTop: "1%" }}>CashInvoice Charges</h5>
                    </div>
                    <div className="mb-3 row">
                      <Row>
                        {commercialFieldsData?.map((field) => (
                          validation.values.product === 'Receivable Financing' && field.fieldName === 'selfFinanaces' ? null :
                            <>
                              <Label className="form-label mt-4 font-size-14">
                                {`${field.fieldLabel}`}
                              </Label>

                              <Col key={field.id} sm="12" md="3">
                                <Label className="form-label mt-2 font-size-12">
                                  Type
                                </Label>
                                <Input
                                  name={`${field.fieldName}Type`}
                                  type="select"
                                  placeholder={`Select ${field.fieldLabel} Type`}
                                  onChange={validation.handleChange} // Let Formik handle the change
                                  onBlur={validation.handleBlur}
                                  value={
                                    validation.values[`${field.fieldName}Type`] ||
                                    ""
                                  }
                                  invalid={
                                    !!(validation.touched[
                                      `${field.fieldName}Type`
                                    ] &&
                                      validation.errors[`${field.fieldName}Type`])
                                  }
                                >
                                  <option value="" disabled>Select</option>
                                  <option value="Flat">Flat</option>
                                  <option value="Percentage">Percentage</option>
                                </Input>
                                {validation.touched[`${field.fieldName}Type`] &&
                                  validation.errors[`${field.fieldName}Type`] ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors[`${field.fieldName}Type`]}
                                  </FormFeedback>
                                ) : null}
                              </Col>

                              <Col key={field.id + 1} sm="12" md="3">
                                <Label className="form-label mt-2">
                                  Frequency
                                </Label>
                                <Input
                                  name={`${field.fieldName}Frequency`}
                                  type="select"
                                  placeholder={`Select ${field.fieldLabel} Frequency`}
                                  onChange={validation.handleChange} // Let Formik handle the change
                                  onBlur={validation.handleBlur}
                                  value={
                                    validation.values[`${field.fieldName}Frequency`] ||
                                    ""
                                  }
                                  invalid={
                                    !!(validation.touched[
                                      `${field.fieldName}Frequency`
                                    ] &&
                                      validation.errors[`${field.fieldName}Frequency`])
                                  }
                                >
                                  <option value="" disabled>Select</option>
                                  <option value="Recurring">Recurring</option>
                                  <option value="One time">One time</option>
                                </Input>
                                {validation.touched[`${field.fieldName}Frequency`] &&
                                  validation.errors[`${field.fieldName}Frequency`] ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors[`${field.fieldName}Frequency`]}
                                  </FormFeedback>
                                ) : null}
                              </Col>

                              <Col key={field.id + 2} sm="12" md="3">
                                <Label className="form-label mt-2">
                                  Occurrence
                                </Label>
                                <Input
                                  name={`${field.fieldName}Occurrence`}
                                  type="select"
                                  placeholder={
                                    validation.values[`${field.fieldName}Time`] === "One Time"
                                      ? "Not Applicable"
                                      : `Select ${field.fieldLabel} Occurrence`
                                  }
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={
                                    validation.values[`${field.fieldName}Frequency`] === "One time"
                                      ? ""
                                      : validation.values[`${field.fieldName}Occurrence`] || ""
                                  }
                                  invalid={
                                    !!(validation.touched[
                                      `${field.fieldName}Occurrence`
                                    ] &&
                                      validation.errors[`${field.fieldName}Occurrence`])
                                  }
                                  disabled={validation.values[`${field.fieldName}Frequency`] === "One time"}
                                >
                                  <option value="" disabled>{
                                    validation.values[`${field.fieldName}Frequency`] === "One time"
                                      ? "Not Applicable"
                                      : `Select`
                                  }</option>
                                  <option value="Per Annum">Per Annum</option>
                                  <option value="Per Month">Per Month</option>
                                  <option value="At Invoice">At Invoice</option>
                                  <option value="AUM">AUM</option>

                                </Input>
                                {validation.touched[`${field.fieldName}Occurrence`] &&
                                  validation.errors[`${field.fieldName}Occurrence`] ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors[`${field.fieldName}Occurrence`]}
                                  </FormFeedback>
                                ) : null}
                              </Col>

                              <Col sm="12" md="3">
                                <Label className="form-label mt-2">
                                  Value
                                </Label>
                                <Input
                                  name={`${field.fieldName}Value`}
                                  type="text"
                                  // step="0.01"
                                  placeholder={`Enter ${field.fieldLabel}`}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={
                                    validation.values[
                                    `${field.fieldName}Value`
                                    ] || ""
                                  }
                                  invalid={
                                    !!(validation.touched[
                                      `${field.fieldName}Value`
                                    ] &&
                                      validation.errors[`${field.fieldName}Value`])
                                  }
                                />
                                {validation.touched[`${field.fieldName}Value`] &&
                                  validation.errors[`${field.fieldName}Value`] ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors[`${field.fieldName}Value`]}
                                  </FormFeedback>
                                ) : null}
                              </Col>
                            </>
                        ))}
                      </Row>
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4"><b>Financier Charges: </b>
                          <span>  At Actuals As Decided By Banks/NBFCs</span>
                        </Label>
                      </Col>
                    </div>
                    <Row>
                      {!isAlready && (
                        <Col>
                          <div className="d-flex gap-3 justify-content-end">
                            <button
                              className="btn btn-outline-secondary"
                              onClick={handleCancel}
                              type="button"
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              className="btn btn-success save-customer"
                            >
                              Save
                            </button>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
      <Loader show={loader} type="box" message="Saving Commercials" />
    </React.Fragment>
  );
};

export default withRouter(AddCommercials);

let commercialFieldsData = [
  {
    id: 1,
    fieldName: "integrationFees",
    fieldLabel: "Fin Weave Integration Fees",
  },
  {
    id: 2,
    fieldName: "syndicationFees",
    fieldLabel: "Syndication Charges",
  },
  {
    id: 3,
    fieldName: "platformCharges",
    fieldLabel: "Platform Charges",
  },
  // {
  //   id: 4,
  //   fieldName: "financesCharges",
  //   fieldLabel: "Finances Charges",
  // },
  {
    id: 4,
    fieldName: "selfFinanaces",
    fieldLabel: "Self Finances / Early Payment",
  },
];
